<template>
  <v-dialog v-model="dialogModel" max-width="400px" persistent :fullscreen="isMobile">
    <v-card>
      <v-card-text>

        <v-flex xs12>
          <v-menu
            full-width
            max-width="290"
            v-model="menuDateModel"
          >
            <v-text-field
              v-model="dateModel"
              slot="activator"
              label="Date"
              append-icon="event"
              :rules="[rules.date]"
              readonly
            ></v-text-field>
            <v-date-picker v-model="dateModel" :min="minDate" scrollable></v-date-picker>
          </v-menu>
        </v-flex>

        <v-flex xs12>
          <v-text-field
            label="Time"
            value="12:30"
            v-model="timeModel"
            type="time"
          ></v-text-field>

          <!--<v-menu-->
            <!--v-else="isMobile"-->
            <!--full-width-->
            <!--v-model="menuTimeModel"-->
            <!--:close-on-content-click="false"-->
          <!--&gt;-->
            <!--<v-text-field-->
              <!--v-model="timeModel"-->
              <!--slot="activator"-->
              <!--label="Time"-->
              <!--append-icon="timelapse"-->
              <!--readonly-->
            <!--&gt;</v-text-field>-->
            <!--<v-time-picker v-model="timeModel" full-width @change="menuTimeModel = false"></v-time-picker>-->
          <!--</v-menu>-->
        </v-flex>

        <!--
        <v-flex xs12>
          <v-text-field
            v-model="caseName"
            label="New case name"
            append-icon="save"
          ></v-text-field>
        </v-flex>
        -->

      </v-card-text>
      <v-card-actions>
        <v-btn color="error" flat @click="dialogModel = false">Close</v-btn>
        <v-btn color="primary" flat block v-if="dateValidation(dateModel)" @click="saveNewCase" :loading="addLoading">Add case</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import casesAPI from '@/api/resources/cases'
  import IsMobile from '@/mixins/IsMobile'
  import moment from 'moment'

  export default {
    mixins: [ IsMobile ],
    data () {
      return {
        menuDateModel: false,
        menuTimeModel: false,
        caseName: null,
        timeModel: null,
        dateModel: null,
        minDate: moment().format('YYYY-MM-DD'),
        isMobile: false,
        addLoading: false,
        rules: {
          date: d => moment(d).utc().isAfter(moment().subtract(1, 'day')) || 'Wrong Date.'
          // time: t => ((moment().format('YYYY-MM-DD') !== this.dateModel) && (moment().diff(moment(t, 'HH:mm'), 'minutes') > 1)) || 'Wrong Time' todo
        }
      }
    },
    computed: {
      dialogModel: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
        }
      }
    },
    methods: {
      saveNewCase () {
        this.addLoading = true
        casesAPI.saveCase({ name: this.caseName }).then(result => {
          this.dialogModel = false
          this.addLoading = false
          this.$store.dispatch('loadAllCases')
          this.$router.push({ name: 'NewLeads', params: { date: this.dateModel, time: this.timeModel, caseId: result.inserted_id } })
        }, () => {
          this.dialogModel = false
          this.addLoading = false
        })
      },
      setDate (newDate) {
        this.dateModel = newDate
      },
      dateValidation (date) {
        return moment(date).utc().isAfter(moment().subtract(1, 'day'))
      }
    },
    watch: {
      date (val) {
        this.setDate(val)
      },
      timeModel () {
        this.timeModel.match(/^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/)
      }
    },
    props: {
      value: {
        type: Boolean,
        required: true,
        default: false
      },
      date: {
        type: String,
        required: true,
        default: false
      }
    },
    created () {
      this.setDate(this.date)
    },
    mounted () {
      if (this.DetectMobile()) {
        this.isMobile = true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AddCaseNameAndDateDialog.vue?21b69867